import React from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import { Container } from '../../components'
import { Content } from './components'
import styles from './register-organization-confirmation.module.css'

const RegisterOrganizationConfirmation = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderOnlyLayout>
        <Container className="px-0 sm:px-0">
          <Content />
        </Container>
      </HeaderOnlyLayout>
    </div>
  )
}

export { RegisterOrganizationConfirmation }
